import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Popup } from "devextreme-react";
import FormConfig from "./formConfig";
import FormMatriz from "./formMatriz";
import { setHideShowWizard, setStepWizard, resetBlockingState } from "../actions";
import { ModalTitleSteps } from "../../../../../Shared/ModalTitleSteps";

class ModalWizardBlocking extends React.PureComponent {
  getStep = () => {
    const currentSteps = { ...this.props.steps };
    if (currentSteps.stepOne === true) return 1;
    if (currentSteps.stepTwo === true) return 2;
  }

  handleClose = () => {
    this.props.dispatch(setStepWizard({
      isNewApertura: true,
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepSuccess: false,
    }));
    this.props.dispatch(setHideShowWizard(false));
    this.props.dispatch(resetBlockingState(this.props.centerId));
    this.props.stopSignalR()
  }

  render() {
    return (
      <Popup
        visible={this.props.isPopupWizardOpen}
        showTitle
        width={800}
        height={550}
        onHiding={this.handleClose}
        showCloseButton
        dragEnabled={false}
        titleTemplate={(element) => {
          ReactDOM.render(
            <ModalTitleSteps
              title={this.props.steps.isNewApertura ? "Agregar Bloqueo" : "Editar Apertura"}
              currentStep={this.getStep()}
              totalSteps={2}
              onClose={this.handleClose}              
            />
            , element
          );
        }}
      >
        <div>
          {this.props.steps.stepOne && this.props.isPopupWizardOpen && <FormConfig />}
          {this.props.steps.stepTwo && <FormMatriz connectionHub={this.props.connectionHub}/>}
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => ({
  isPopupWizardOpen: state.bloqueosSel.isPopupWizardOpen,
  blocking: state.bloqueosSel.blocking,
  steps: state.bloqueosSel.steps,
  centerId: state.bloqueosSel.centerId
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalWizardBlocking);
